import axios from "axios";

export function fetchItemsWS(endpoint, queryParams, getState) {
  const state = getState();
  const jwtToken = state.authData[0]?.signInUserSession.accessToken.jwtToken;

  const headers = {
    Authorization: `Bearer ${jwtToken}`,
  };

  const queryString = Object.keys(queryParams)
    .map((key) => `${key}=${queryParams[key]}`)
    .join("&");

  const apiUrl = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/${endpoint}?${queryString}`;
  return axios
    .get(apiUrl, {
      headers: headers,
    })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
}
